import type transform from '../to/periods';

export default (periods: ReturnType<typeof transform>) => {
  if (periods.length != new Set(periods.map(x => x.id)).size)
    throw new Error('(Core::From::V2::Periods) Periods array have two or more periods with the same ID');

  return periods
    .map(x => {
      if (!x.id)
        throw new Error('(Core::From::V2::Periods) Period id is undefined');

      return { ...x };
    });
};
